import { Button, Input, Textarea } from '@material-tailwind/react'
import React, { useState, useRef } from 'react'
import { ErrorMessage } from '@hookform/error-message';
import AIcon from '../partials/AIcon'

export default function AInput({ v }) {

    const [showPassword, setShowPassword] = useState(false)
    const dateRef = useRef();
    const showDatePicker = () => {
        dateRef.current.showPicker();
    };

    const getStyle = () => !v.data?.isStyle ? " before:content-none" : '';

    const getIcon = (d) => {
        return v.data.type === 'password' ?
            <Button onClick={() => setShowPassword(pre => !pre)} className='p-1 bg-transparent shadow-none hover:shadow-none'>{d}</Button> : d
    }

    const handleShowPassword = () => {
        setShowPassword(pre => !pre)
    }


    return (
        <>{!v.data.hide &&
            <div className={`flex flex-col ${v.data?.className}`}>
                {!v.data?.isStyle && <p className="text-base text-black font-semibold amiriB px-2">{v.data?.label}  
                {v.data?.required&& <span className='text-red-700'>*</span>} 
                {v.data?.note&& <span className='text-gray-600 text-xs mx-2'>{v.data?.note}</span>} 
                </p>}

                {v.data?.type === "text" || v.data?.type === "number"|| v.data?.type === "tel" || v.data?.type === "password" || v.data?.type === "email" || v.data?.type === "date" ?
                    <Input
                        style={{direction:v?.data?.dirct}}
                        onClick={showDatePicker}
                        className={`${v.data?.type === "date" ? ' cursor-pointer' : ''} `}
                        type={showPassword ? 'text' : v.data?.type}
                        step={ v.data?.type==='number'? 0.01:''}
                        disabled={v?.data?.isDisabled}
                        placeholder={!v.data?.isStyle ? v.data?.label : ''}
                        label={v.data?.isStyle ? v.data?.label : ''}
                        inputRef={dateRef}
                        color="purple"
                        onWheel={(e) => e.target.blur()}
                        {...v?.register(v.data?.name, { required: v.data?.required })}

                        icon={v.data?.icon && getIcon(<AIcon onClick={showDatePicker}
                            name={showPassword ? 'eye-off-outline' : v.data?.icon} size={v.data?.type === 'password' ? 18 : ''}
                            className={`${v.data?.type === "date" && ' cursor-pointer'} h-5 w-5 text-main-color`} />)
                        }
                        error={v.errors[v.data['name']] ? true : false}
                        labelProps={{
                            className: getStyle(),
                        }}
                    /> :
                    <Textarea
                        rows={1} type={v.data?.type}
                        disabled={v?.data?.isDisabled}
                        placeholder={!v.data?.isStyle && v.data?.label}
                        label={v.data?.isStyle ? v.data?.label : ''}
                        color="purple" className="min-h-[70px]"
                        {...v?.register(v?.data?.name, { required: v.data?.required })}
                        labelProps={{
                            className: getStyle(),
                        }} />
                }
                {v.errors[v?.data['name']] && v.data?.required && <small className="text-red-600">{v.data?.required}</small>}
                
            </div>
            } </>
    )
}
